<ng-template [ngIf]="templateUtenteForm && display">
<div>
	<div class="col-sm-12 coldx">
		<h4>{{title}}</h4>
		<form #f="ngForm" [formGroup]="templateUtenteForm"
			(ngSubmit)="update();">
			<div class="row" *ngIf="!utente">
				<div textInput [control]="templateUtenteForm.controls['label']"
					class="col-xs-12 col-sm-12" [labelInput]="'Titolo template utente'"
					formControlName="label" [mandatory]="true"
					[(ngModel)]="request.label"></div>
			</div>
			<div class="row" *ngIf="utente && !addMod">
				<div
					comboModInput [control]="templateUtenteForm.controls['templateProfilo']"
					class="col-xs-12 col-sm-12" [labelInput]="'Template di profilo'"
					formControlName="templateProfilo" [objectReference]="request"
					[ngModel]="request" (onReturn)="request = $event"
					[optionsCombo] ="listaTemplateUtente"
					(change)="onChangeTemplate(request.id);"></div>
			</div>
			<div class="gruppi_competenza template-utente">
				<h3 class="titletogglepanel titlelevelcompetenza">
					<a data-toggle="collapse" href="#subgruppo_competenza1{{addMod}}"
						aria-expanded="false" [attr.aria-controls]="'subgruppo_competenza1' + addMod"
						class="collapsed"><span
						*ngIf="utente" class="mandatory">* </span>Gruppi
						operativi</a>
				</h3>
				<div id="subgruppo_competenza1{{addMod}}"
					class="collapse togglepanel">
					<div class="row">
						<p class="col-sm-12 col-xs-12">
							<input type="text" #searchItemGruppiOperativi (keyup)="0"
								class="form-control" placeholder="Cerca" />
					</div>
					<div class="row">
						<ul class="gruppi">
							<ng-template ngFor
								let-gruppoOperativo [ngForOf]="listaGruppiOperativi | searchFilter : searchItemGruppiOperativi.value : 'nomeGruppo'"
								let-i=index>
							<li>
								<div class="col-sm-12">
									<p class="active singlecheckbox" style="display: flex;align-items: baseline;">
										<span class="col-xs-9 col-sm-11"><label class="fakelabel">{{gruppoOperativo.nomeGruppo | tipoPraticaPipe}}</label></span>
										<input class="col-xs-3 col-sm-1" name="gruppoOperativo{{ gruppoOperativo.id+addMod }}"
											id="gruppoOperativo{{ gruppoOperativo.id+addMod }}"
											value="gruppoOperativo{{ gruppoOperativo.id+addMod }}"
											(click)="onCheckGruppo(request.templateProfiloGruppiOperativi, gruppoOperativo)"
											type="checkbox"
											[checked]="isCheckedGruppo(request.templateProfiloGruppiOperativi,gruppoOperativo)">
										<label for="gruppoOperativo{{ gruppoOperativo.id+addMod }}">
											<small class="sr-only">
												{{
													isCheckedGruppo(request.templateProfiloGruppiOperativi,gruppoOperativo) ? 
													'Seleziona' + gruppoOperativo.nomeGruppo : 'Deseleziona' + gruppoOperativo.nomeGruppo
												}}	
											</small> 
										</label>
									</p>
								</div>
							</li>
							</ng-template>
						</ul>
					</div>
				</div>
			</div>
			<div class="gruppi_competenza template-utente">
				<h3 class="titletogglepanel titlelevelcompetenza">
					<a data-toggle="collapse" href="#subgruppo_competenza2{{addMod}}"
						aria-expanded="false"
						[attr.aria-controls]="'subgruppo_competenza2' + addMod" class="collapsed"><span
						*ngIf="utente" class="mandatory">* </span>Gruppi organizzativi</a>
				</h3>
				<div id="subgruppo_competenza2{{addMod}}"
					class="collapse togglepanel">
					<div class="row">
						<p class="col-sm-12 col-xs-12">
							<input type="text" #searchItemGruppiOrganizzativi (keyup)="0"
								class="form-control" placeholder="Cerca" />
						</p>
					</div>
					<div class="row">
						<ul class="gruppi" 
							role="radiogroup" 
							aria-labelledby="labelGruppiOrganizzativi">
							<p id="labelGruppiOrganizzativi" class="sr-only">
								Scegli un gruppo organizzativo
							</p>

							<ng-template ngFor
								let-gruppoOrganizzativo 
								[ngForOf]="listaGruppiOrganizzativi | searchFilter : searchItemGruppiOrganizzativi.value : 'nomeGruppo'"
								let-i=index>

								<li>
									<div class="col-sm-12">
										<p class="active singlecheckbox radiobutton"
										style="display: flex; align-items: baseline;">

											<span class="col-xs-9 col-sm-11">
												<label class="fakelabel">{{ gruppoOrganizzativo.nomeGruppo }}</label>
											</span>

											<input class="col-xs-3 col-sm-1"
												name="gruppoOrganizzativo"
												id="gruppoOrganizzativo{{ gruppoOrganizzativo.id + addMod }}"
												value="gruppoOrganizzativo{{ gruppoOrganizzativo.id + addMod }}"
												(click)="onCheckGruppoOrganizzativo(request.templateProfiloGruppiOrganizzativi, gruppoOrganizzativo)"
												type="radio"
												[checked]="isCheckedGruppo(request.templateProfiloGruppiOrganizzativi, gruppoOrganizzativo)"
												[attr.aria-labelledby]="'labelGruppo_' + (gruppoOrganizzativo.id + addMod)" />

											<label 
												[attr.id]="'labelGruppo_' + (gruppoOrganizzativo.id + addMod)"
												[attr.for]="'gruppoOrganizzativo' + (gruppoOrganizzativo.id + addMod)">

												<small class="sr-only">
													{{
														isCheckedGruppo(request.templateProfiloGruppiOrganizzativi, gruppoOrganizzativo)
															? 'Deseleziona ' + gruppoOrganizzativo.nomeGruppo
															: 'Seleziona ' + gruppoOrganizzativo.nomeGruppo
													}}
												</small>
											</label>

										</p>
									</div>
								</li>
							</ng-template>
						</ul>

					</div>
				</div>
			</div>

	

			<div class="gruppi_competenza template-utente">
				<h3 class="titletogglepanel titlelevelcompetenza">
					<a data-toggle="collapse" href="#subgruppo_visibilitaOperativitaGruppo{{addMod}}"
					aria-expanded="false"
					[attr.aria-controls] ="'subgruppo_visibilitaOperativitaGruppo'+ addMod"
					class="collapsed">
					Visibilità e operatività per gruppo organizzativo
					</a>
				</h3>

				<div id="subgruppo_visibilitaOperativitaGruppo{{addMod}}" class="collapse togglepanel">

					<!-- Selezione gruppi -->
					<div class="row">
						<p class="col-sm-12 col-xs-12">
							<input type="text" #searchGruppi class="form-control" placeholder="Cerca" />
						</p>
					</div>
					<div *ngIf="!isSezionePermessiBloccata(); else bloccaSezione" class="row">
						<ul class="gruppi">
							<li *ngFor="let gruppo of listaGruppiOrganizzativi | searchFilter : searchGruppi.value : 'nomeGruppo'">
								<ng-container *ngIf="!isCheckedGruppo(request.templateProfiloGruppiOrganizzativi, gruppo)">
									<div class="col-sm-12">
										<p class="active singlecheckbox" style="display: flex;align-items: baseline;">
										<span class="col-xs-9 col-sm-11">
											<label class="fakelabel">{{ gruppo.nomeGruppo }}</label>
										</span>
										<input class="col-xs-3 col-sm-1"
											name="gruppo{{ gruppo.nomeGruppo+addMod }}"
											type="checkbox"
											id="gruppo{{ gruppo.id+addMod }}"
											value="gruppo{{ gruppo.id+addMod }}"
											[checked]="isGruppoPermessiSelezionato(gruppo)"
											(change)="onToggleGruppoPermessi(gruppo)">
											<label for="gruppo{{ gruppo.id+addMod }}">
												<small class="sr-only">
													{{
														isGruppoPermessiSelezionato(gruppo) ? 
														'Seleziona' + gruppo.nomeGruppo : 'Deseleziona' + gruppo.nomeGruppo
													}}	
												</small> 
											</label>
										</p>
									</div>
								</ng-container>

								<!-- Accordion dei permessi per ciascun gruppo selezionato -->
								<div *ngIf="isGruppoPermessiSelezionato(gruppo)" class="gruppi_competenza template-utente">
									<h4 class="titletogglepanel" (click)="togglePermessi(gruppo)" [title]="isPermessiAperto(gruppo) ? 'Riduci' : 'Espandi'">Permessi</h4>
									<div [attr.id]="'permessiGruppo' + sanitizeId(gruppo.id + addMod)" class="togglepanel" style="padding: unset !important;">
										<div *ngIf="isPermessiAperto(gruppo)" [attr.id]="'permessiGruppo' + sanitizeId(gruppo.id + addMod)" class="togglepanel">										
											<table class="table template-utente">
												<thead>
													<tr>
														<th class="col-xs-4">Nome</th>
														<th class="col-xs-4">Lettura</th>
														<th class="col-xs-4">Scrittura</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let permesso of permessiCustom | searchFilter : searchItemPermessi.value : 'readPermission.nomeGruppo'; let i = index">
														<td>
															<span class="col-sm-8"><div style="font-weight: normal;" class="fakelabel">{{permesso.readPermission.nomeGruppo.replace('Leggi','').trim()}}</div></span>
														</td>
														<td>
															<input name="permessoGruppoRead{{ gruppo.id+permesso.readPermission.id+addMod }}"
																id="permessoGruppoRead{{i}}" value="permessoGruppoRead{{ gruppo.id+permesso.readPermission.id+addMod }}"
																(click)="onCheckPermessoGruppo(gruppo, permesso.readPermission)" type="checkbox"
																[disabled]="permesso.writePermission && isCheckedPermessoGruppo(gruppo, permesso.writePermission)"
																[checked]="isCheckedPermessoGruppo(gruppo, permesso.readPermission)">
															<label style="position: relative;" for="permessoGruppoRead{{i}}">
																<span class="sr-only">Permesso lettura {{ permesso.readPermission.nomeGruppo }}</span>
															</label>
														</td>
														<td>
															<input *ngIf="permesso.writePermission" name="permessoGruppoWrite{{ gruppo.id+permesso.writePermission.id+addMod }}"
																id="permessoGruppoWrite{{i}}"
																value="permessoGruppoWrite{{ gruppo.id+permesso.writePermission.id+addMod }}" (click)="onCheckPermessoGruppo(gruppo, permesso.writePermission)" type="checkbox"
																[checked]="isCheckedPermessoGruppo(gruppo, permesso.writePermission)">
															<label style="position: relative;" *ngIf="permesso.writePermission" for="permessoGruppoWrite{{i}}">
																<span class="sr-only">Permesso scrittura {{ permesso.writePermission.nomeGruppo }}</span>
															</label>
															<input *ngIf="!permesso.writePermission"
																name="permessoGruppoWriteDisabled{{ gruppo.id+permesso.readPermission.id.replace('_R_', '_W_')+addMod }}"
																id="permessoGruppoWriteDisabled{{i}}"
																value="permessoGruppoWriteDisabled{{ gruppo.id+permesso.readPermission.id+addMod }}" [disabled]="true" type="checkbox"> 
																	<label style="position: relative;"
																		*ngIf="!permesso.writePermission"
																		for="permessoGruppoWriteDisabled{{i}}">
																		<span class="sr-only">Permesso scrittura non disponibile</span>
																	</label>
														</td>
													</tr>
												</tbody>
											</table>					
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<ng-template #bloccaSezione>
				<p class="text-muted">Seleziona prima un gruppo organizzativo principale per modificare questa sezione</p>
			</ng-template>

			<div class="gruppi_competenza template-utente">
				<h3 class="titletogglepanel titlelevelcompetenza">
					<a data-toggle="collapse" href="#subgruppo_competenza3{{addMod}}"
						aria-expanded="false"
						[attr.aria-controls]="'subgruppo_competenza3' + addMod" class="collapsed">Gruppi
						di visibilit&agrave; per consultazione</a>
				</h3>
				<div id="subgruppo_competenza3{{addMod}}"
					class="collapse togglepanel">
					<div class="row">
						<p class="col-sm-12 col-xs-12">
							<input type="text" #searchItemGruppiVisibilita (keyup)="0"
								class="form-control" placeholder="Cerca" />
						</p>
					</div>
					<div class="row">
						<ul class="gruppi">
							<ng-template ngFor
								let-gruppoVisibilita [ngForOf]="listaGruppiVisibilita | searchFilter : searchItemGruppiVisibilita.value : 'nomeGruppo'"
								let-i=index>
							<li>
								<div class="col-sm-12">
									<p class="active singlecheckbox" style="display: flex;align-items: baseline;">
										<span class="col-xs-9 col-sm-11"><label class="fakelabel">{{gruppoVisibilita.nomeGruppo}}</label></span>
										<!-- <div class="col-xs-3 col-sm-1">

										</div> -->
										<input class="col-xs-3 col-sm-1" name="gruppoVisibilita{{ gruppoVisibilita.id+addMod }}"
											id="gruppoVisibilita{{ gruppoVisibilita.id+addMod }}"
											value="gruppoVisibilita{{ gruppoVisibilita.id+addMod }}"
											(click)="onCheckGruppo(request.templateProfiloGruppiVisibilita, gruppoVisibilita)"
											type="checkbox"
											[checked]="isCheckedGruppo(request.templateProfiloGruppiVisibilita,gruppoVisibilita)">
										<label for="gruppoVisibilita{{ gruppoVisibilita.id+addMod }}">
											<small class="sr-only">
												{{
													isCheckedGruppo(request.templateProfiloGruppiVisibilita,gruppoVisibilita) ? 
													'Seleziona' + gruppoVisibilita.nomeGruppo : 'Deseleziona' + gruppoVisibilita.nomeGruppo
												}}	
											</small> 
										</label>
									</p>
								</div>
							</li>
							</ng-template>
						</ul>
					</div>
				</div>
			</div>

			<div class="gruppi_competenza template-utente">
				<h3 class="titletogglepanel titlelevelcompetenza">
					<a data-toggle="collapse" href="#subgruppo_competenza4{{addMod}}"
						aria-expanded="false"
						[attr.aria-controls]="'subgruppo_competenza4' + addMod" class="collapsed">Gruppi
						Speciali</a>
				</h3>
				<div id="subgruppo_competenza4{{addMod}}"
					class="collapse togglepanel">
					<div class="row">
						<p class="col-sm-12 col-xs-12">
							<input type="text" #searchItemGruppiSpeciali (keyup)="0"
								class="form-control" placeholder="Cerca" />
					</div>

					<div class="row">
						<ul class="gruppi">
							<ng-template ngFor
								let-gruppoSpeciale [ngForOf]="listaGruppiSpeciali | searchFilter : searchItemGruppiSpeciali.value : 'nomeGruppo'"
								let-i=index>
							<li>
								<div class="col-sm-12">
									<p class="active singlecheckbox"  style="display: flex;align-items: baseline;">
										<span class="col-xs-9 col-sm-11"><label class="fakelabel">{{gruppoSpeciale.nomeGruppo}}</label></span>
										<input class="col-xs-3 col-sm-1" name="gruppoSpeciale{{ gruppoSpeciale.id+addMod }}"
											id="gruppoSpeciale{{ gruppoSpeciale.id+addMod }}"
											value="gruppoSpeciale{{ gruppoSpeciale.id+addMod }}"
											(click)="onCheckGruppo(request.templateProfiloGruppiSpeciali, gruppoSpeciale)"
											type="checkbox"
											[checked]="isCheckedGruppo(request.templateProfiloGruppiSpeciali, gruppoSpeciale)">
										<label for="gruppoSpeciale{{ gruppoSpeciale.id+addMod }}">
											<small class="sr-only">
												{{
													isCheckedGruppo(request.templateProfiloGruppiSpeciali, gruppoSpeciale) ? 
													'Seleziona' + gruppoSpeciale.nomeGruppo : 'Deseleziona' + gruppoSpeciale.nomeGruppo
												}}	
											</small> 
										</label>
									</p>
								</div>
							</li>
							</ng-template>
						</ul>
					</div>
				</div>
			</div>

			<div class="gruppi_competenza template-utente">
				<h3 class="titletogglepanel titlelevelcompetenza">
					<a data-toggle="collapse" href="#subgruppo_competenza5{{addMod}}"
						aria-expanded="false"
						[attr.aria-controls]="'subgruppo_competenza5' + addMod" class="collapsed">Ruoli</a>
				</h3>
				<div id="subgruppo_competenza5{{addMod}}"
					class="collapse togglepanel">
					<div class="row">
						<p class="col-sm-12 col-xs-12">
							<input type="text" #searchItemRuoli (keyup)="0"
								class="form-control" placeholder="Cerca" />
					</div>

					<div class="row">
						<ul class="gruppi">
							<ng-template ngFor
								let-ruolo [ngForOf]="listaRuoli | searchFilter : searchItemRuoli.value : 'nomeGruppo'"
								let-i=index>
							<li>
								<div class="col-sm-12">
									<p class="active singlecheckbox" style="display: flex;align-items: baseline;">
										<span class="col-xs-9 col-sm-11"><label class="fakelabel">{{ruolo.nomeGruppo}}</label></span>
										<input class="col-xs-3 col-sm-1" name="ruolo{{ ruolo.id+addMod }}"
											id="ruolo{{ ruolo.id+addMod }}"
											value="ruolo{{ ruolo.id+addMod }}"
											(click)="onCheckGruppoRuolo(request.templateProfiloRuoli, ruolo)"
											type="checkbox"
											[checked]="isCheckedGruppo(request.templateProfiloRuoli,ruolo)">
										<label for="ruolo{{ ruolo.id+addMod}}">
											<small class="sr-only">
												{{
													isCheckedGruppo(request.templateProfiloRuoli,ruolo) ? 
													'Seleziona' + ruolo.nomeGruppo : 'Deseleziona' + ruolo.nomeGruppo
												}}	
											</small> 
										</label>
									</p>
								</div>
							</li>
							</ng-template>
						</ul>
					</div>
				</div>
			</div>

			<div class="gruppi_competenza template-utente">
				<h3 class="titletogglepanel titlelevelcompetenza">
					<a data-toggle="collapse" href="#subgruppo_competenza6{{addMod}}"
						aria-expanded="false"
						[attr.aria-controls]="'subgruppo_competenza6' + addMod" class="collapsed"><span
						class="mandatory">* </span>Permessi</a>
				</h3>
				<div id="subgruppo_competenza6{{addMod}}"
					class="collapse togglepanel">
					<div class="row">
						<p class="col-sm-11 col-xs-11">
							<input type="text" #searchItemPermessi (keyup)="0"
								class="form-control" placeholder="Cerca" />
						</p>
					</div>

					<div class="row">
						<table class="table template-utente">
							<caption class="sr-only">Tabella templete utente</caption>
							<thead>
								<tr>
									<th class="col-xs-4">Nome</th>
									<th class="col-xs-4">Lettura</th>
									<th class="col-xs-4">Scrittura</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let permesso of permessiCustom | searchFilter : searchItemPermessi.value : 'readPermission.nomeGruppo'">
									<td>
										<span class="col-sm-8"><div style="font-weight: normal;" class="fakelabel">{{permesso.readPermission.nomeGruppo.replace('Leggi','').trim()}}</div></span>
									</td>
									<td>
										<input name="permessoRead{{ permesso.readPermission.id+addMod }}"
											id="permessoRead{{ permesso.readPermission.id+addMod }}" value="permessoRead{{ permesso.readPermission.id+addMod }}"
											(click)="onCheckGruppoRead(permesso)" type="checkbox"
											[disabled]="((permesso.writePermission) && (isCheckedGruppo(request.templateProfiloPermessi, permesso.writePermission)))"
											[checked]="isCheckedGruppo(request.templateProfiloPermessi,permesso.readPermission)">
										<label style="position: relative;" for="permessoRead{{ permesso.readPermission.id+addMod }}">
											<small class="sr-only">
												{{
													isCheckedGruppo(request.templateProfiloPermessi,permesso.readPermission) ? 
													'Seleziona' + permesso.readPermission.nomeGruppo : 'Deseleziona' + permesso.readPermission.nomeGruppo
												}}	
											</small> 
										</label>
									</td>
									<td>
										<input *ngIf="permesso.writePermission" name="permessoWrite{{ permesso.writePermission.id+addMod }}"
											id="permessoWrite{{ permesso.writePermission.id+addMod }}"
											value="permessoWrite{{ permesso.writePermission.id+addMod }}" (click)="onCheckGruppoWrite(permesso)" type="checkbox"
											[checked]="isCheckedGruppo(request.templateProfiloPermessi,permesso.writePermission)">
										<label style="position: relative;" *ngIf="permesso.writePermission" for="permessoWrite{{ permesso.writePermission.id+addMod }}">
											<small class="sr-only">
												{{
													isCheckedGruppo(request.templateProfiloPermessi,permesso.writePermission) ? 
													'Seleziona' + permesso.readPermission.nomeGruppo : 'Deseleziona' + permesso.readPermission.nomeGruppo
												}}	
											</small> 
										</label>
										<input *ngIf="!permesso.writePermission"
											name="permessoWriteDisabled{{ permesso.readPermission.id.replace('_R_', '_W_')+addMod }}"
											id="permessoWriteDisabled{{ permesso.readPermission.id+addMod }}"
											value="permessoWriteDisabled{{ permesso.readPermission.id+addMod }}" [disabled]="true" type="checkbox"> 
											<label style="position: relative;"
												*ngIf="!permesso.writePermission"
												for="permessoWriteDisabled{{ permesso.readPermission.id+addMod }}">
													<small class="sr-only">
														Seleziona o deseleziona permesso
													</small> 
											</label>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<div class="">
				<p class="mandatory">
					<em>* Campi obbligatori</em>
				</p>
			</div>
			<div *ngIf="hasGruppiOrganizzativiSelezionati && hasGruppiSpecialiSelezionati" class="conflict-box" role="alert" aria-live="polite">
				<span class="info-icon" title="Non puoi assegnare insieme un gruppo speciale e la visibilità per singolo gruppo organizzativo!">ℹ️</span>
				<div class="conflict-text">
					<strong>Attenzione:</strong>
					<span class="sr-only">Non puoi assegnare insieme un gruppo speciale e la visibilità per singolo gruppo organizzativo!</span>
					<span class="visible-text">Non puoi assegnare insieme un gruppo speciale e la visibilità per singolo gruppo organizzativo!</span>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-3 col-xs-6">
					<button type="button" class="btn btn-outline-secondary btn-block"
						(click)="createForm()">Reset</button>
				</div>
				<div
					submitButton 
					[disabled]="
					!templateUtenteForm.valid
					|| (!utente && request.templateProfiloPermessi == 0)
					|| (utente && (request.templateProfiloGruppiOrganizzativi.length == 0 || request.templateProfiloPermessi == 0))
					|| (hasGruppiOrganizzativiSelezionati && hasGruppiSpecialiSelezionati)"
					class="col-sm-3 col-xs-6 col-sm-offset-6"
					[labelButton]="'Inserisci e salva'">
				</div>
			</div>
		</form>
	</div>
</div>
</ng-template>
